module.exports = __webpack_public_path__ + "static/img/1.69cd3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon/1.png
// module id = oHDn
// module chunks = 96